import { createStrings } from '@utils/local';

export const paymentDetailsStrings = createStrings({
  ja: {
    cost_id: '項目マスタID',
    name: '支払名目',
    memo: '名目備考',
    unit_price: '単価',
    unit_num: '数量',
    unit_num_type: '単位',
    excise_tax_type: '消費税',
    excise_tax: '消費税',
    non_tax_amount: '税別金額',
  },
} as const);

export const paymentSlipStrings = createStrings({
  ja: {
    payment_slip: '支払伝票',
    change_log: '変更履歴',
    invoice_no: '被請求番号',
    invoice_date: '被請求日',
    memo: '社内備考',
    invoice_file: '業者の請求書',
    payment_slip_no: 'D2D支払番号',
    fc_payment_slip_no: '基幹支払番号',
    payment_type: '支払区分',
    currency: '請求通貨単位',
    conversion_rate: '換算レート',
    conversion_rate_date: '換算レート日付',
    deadline_shimebarai: '締め日',
    deadline_genbarai: '立替締め日',
    payment_date_shimebarai: '支払日',
    payment_date_genbarai: '立替支払日',
    status: '作成状況',
    payment_status: '支払状況',
    total_amount: '支払金額',
    arrival_notice_tag: 'A/N支払伝票Tag',
    arrival_notice_tag_true: 'A/N支払伝票です',
    arrival_notice_tag_false: 'A/N支払伝票ではありません',
    batch_no: 'バッチ番号',
    no: 'NO.',
    otherPayee: 'その他',
    created_at: '作成時間',
    updated_at: '更新時間',
    creator: '作成者',
    subsums: {
      tax_excluded_total_price: '税抜支払総額',
      excise_tax: '仮払消費税',
      tatekae_total_price: '支払立替金額',
    },
    errorFCJapanOnly: 'FC Japan のみが作成・変更できます',
    errorSalespersonOnly: '担当者のみが作成・変更できます',
    errorFCChinaSalespersonExportOnly: 'FC China の場合は担当者のみが閲覧できます',
    errorConversionRateNotExist: '為替レートは無効です。',
    errorCostIdNotFound: (costId: number) => `支払名目ID ${costId} は無効です。`,
    errorInvalidUnitNumType: (name: string, unitNumType: string) =>
      `支払名目${name}の単位${unitNumType}は有効ではありません。`,
    errorUnlockAdminOnly: 'Adminのみがロック解除することができます。Adminにご連絡ください。',
    errorBookingInquiryNotDelivered: 'お届け完了前に支払伝票を全部発行したことにできません。',
    errorPaymentTypeForOtherPayee: '支払先が「その他」の場合は、現払いを選択してください。',
    errorEmptyPayee: '支払先を選択してください。',
    errorInvalidInvoiceDate: '有効な被請求日を入力してください。',
    errorPaymentSlipNotCreated: '全ての支払伝票が作成済前に、全部発行完了にすることができません。',
    errorAlreadyPaymentSlipDone: '既に支払伝票全部発行完了になりました。',
    errorPreAlertLedgerLocked:
      '案件のロックが施錠されています。そのため、支払伝票の変更・追加・解錠は行えません。解錠が必要な場合は、adminにご連絡ください。',
    errorCannotEditPaymentSlip: 'FC Japanは自分が作成した支払伝票のみを変更できます。',
    errorNotFCJapan: 'FC Japan のみは支払伝票を追加・更新できます。',
    errorPaid: '支払済みの支払伝票はロック解除できません。',
    warningAdminUnlock:
      '本当に管理員の権限を利用し、既に送信した支払伝票を取り下げて修正可能なようにしますか？',
    warningSend: '本当に確定しますか？',
    warningPaymentSlipDone: (is_invoice_done: boolean) =>
      'この案件に関連するすべての支払伝票を作成して発行しましたか？' +
      (is_invoice_done
        ? '「確認」を押すと、この案件を「過去の案件」に移動するので、ご了承ください。'
        : ''),
  },
} as const);

export const payeeStrings = createStrings({
  ja: {
    payee: '支払先',
    name_ja: '支払先和文名',
    name_en: '支払先英文名',
    fc_no: 'FC番号',
    principal_name: '担当者名',
    phone: '電話番号',
    email: 'メール',
  },
} as const);

export const EXTERNAL_AN_CREATOR_EMAIL = 'fc.d2d.no.reply@gmail.com';
